<template>
    <div class="content"
         @click="isShow">
        <div class="head">
            <div>
                <p class="title">作业详情</p>
                <p @click="back()"
                   class="back"></p>
                <p class="preview"
                   @click="preview(type)">作业预览</p>
            </div>
        </div>
        <div class="time_box"
             v-if='!is_active'>
            <!-- 期末活动加 -->
            <p class="jzTime">截止时间：{{ endDate }}</p>
            <p class="endTime"
               v-if="flagBoon">已截止</p>
        </div>
        <div class="tabs_tit"
             v-if="!is_active">
            <div class="notab"
                 v-if="taskType=='1'|| (taskType == 2&&testType == 4)">
                完成情况
            </div>
            <div class="tabs"
                 v-else>
                <div>
                    <p @click="tab(1)"
                       :class="[tabNum == 1 ? 'check' : 'nocheck']">完成情况</p>
                </div>
                <div></div>
                <div>
                    <p @click="tab(2)"
                       :class="[tabNum == 2 ? 'check' : 'nocheck']">作业报告</p>
                </div>
            </div>
        </div>
        <div class="tabs_tit marginTop"
             v-if="is_active">
            <div class="notab"
                 style="text-align:center;padding-left:0;">
                完成情况
            </div>
        </div>
        <template v-if="loading">
            <!-- <analyze ref="analyze" :finish_num="finish" :average="average" :anums="anums" :bnums="bnums" :cnums="cnums"
                :dnums="dnums" v-if="tabNum == 1&&(testType==8||testType==11||testType==12)"></analyze> -->
            <results v-if="tabNum == 1"
                     :isActive="is_active"
                     :taskType="taskType"
                     :testType="testType"
                     :finishlist="finshList"
                     :finish="finish"
                     :unfinish="unfinish"
                     :classid="this.classId"
                     :taskid="this.taskId"
                     :reid="this.reid"
                     :wrong_num='wrong_num'></results>
            <reports v-if="tabNum == 2"
                     :taskType="this.taskType"
                     :testType="testType"
                     :knows="knows"
                     :asksList="asksList"
                     :classid="this.classId"
                     :taskid="this.taskId"></reports>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
        <div :class='["bottom_btn",(is_active||flagBoon)&finish>0&&taskType!=4?"bottom_btn1":"bottom_btn2"]'
             v-if="finshList.length>0&&!is_active">
            <div class='bottom_btn-box'>
                <div class="bottom_btn-div reward"
                     @click="reward"
                     v-if="(is_active||flagBoon)&finish>0&&taskType!=4">
                    <p><img src="./img/test_jp.png">奖励和评语</p>
                </div>
                <div class="bottom_btn-div share"
                     @click="reportClick">
                    <p><img src="./img/test_fx.png">分享报告给家长</p>
                </div>
            </div>
        </div>
        <div class="bottom_btn bottom_btn2"
             v-if="is_active">
            <div class='bottom_btn-box'>
                <div class="bottom_btn-div share"
                     @click="HDshare">
                    <p><img src="./img/test_fx.png">分享学生完成情况</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'COMPONENTS/base/tealoading.vue';
import headers from 'COMPONENTS/base/header.vue'
// import analyze from 'SRC/components/activity/schoolopens/tea/analyze.vue';
import results from 'VIEWS/chinese/inspect/resultList.vue'
import reports from 'VIEWS/chinese/inspect/reportList.vue'

export default {
    data () {
        return {
            reid: this.$route.params.reid,
            taskId: this.$route.params.taskid, //作业id
            classId: this.$route.params.classid, //班级id
            taskType: this.$route.params.taskType, //作业类型1课前2课后4课外
            testType: this.$route.params.testType, //1同步习题 2单元复习3高频错题 4生词听写 8开学大检查 11期末大检查
            type: this.$route.params.type, //1:课文预习 2同步习题 3单元复习 4高频错题 5生词听写 6 课外阅读
            test_type: this.$route.query.test_type, //作业类型   4开学大检查
            task_name: this.$route.query.task_name,
            mid: this.$route.query.mid || "",
            url: null,
            tabNum: 1,
            finshList: [], //所有学生列表
            finish: null, //完成学生
            unfinish: null, //未完成
            asksList: [], //错误率数据
            knows: [],
            flagBoon: false, //截止时间
            city: 1111,
            endDate: localStorage.getItem('endDate'),
            students: null,
            loading: false,
            is_active: Number(this.$route.query.is_active) || 0, //活动加 
            wrong_num: 0,
            average: null,
            anums: null,
            bnums: null,
            cnums: null,
            dnums: null,
        }
    },
    created () {
        this.loading = true;
        localStorage.removeItem('tabNum');
        if (localStorage.getItem('tabNum')) {
            this.tabNum = localStorage.getItem('tabNum');
            this.tab(this.tabNum)
        } else {
            this.getlist(this.url);
        }
    },
    destroyed () { },
    methods: {
        isShow () {
            if (this.$refs.analyze) { this.$refs.analyze.isShow = false };
        },
        back () {
            this.$router.go(-1)
            localStorage.setItem('tabNum', 1);
        },
        reportClick () {
            let testType = this.taskType == 4 ? 1 : this.testType;
            this.$router.push("/base/shareToParent/" + this.classId + "/" + this.taskId + "/" + this.taskType + "/" +
                testType + '/51?is_active=' + this.is_active);
        },
        preview (type) { //作业预览
            let taskType = this.taskType,
                testType = this.testType;
            if (taskType == 2 && testType == 4) {
                this.$router.push("/chinese/inspect/preview/words/" + this.taskId + "?taskType=" + taskType)
            } else if (taskType == 4) {
                this.$router.push("/chinese/inspect/outread/preview?reid=" + this.reid)
            } else {
                this.$router.push("/chinese/inspect/preview/task/" + this.taskId + "/" + this.testType)
            }
        },
        tab (num) { //切换
            this.loading = false;
            this.tabNum = num;
            let taskType = this.taskType;
            let testType = this.testType;
            localStorage.setItem('tabNum', this.tabNum);
            if (this.tabNum == 2) {
                if (taskType == 2) {
                    this.$http.post(API_URL_TASK_API + '/chinese/check/question/task/report', {
                        "message_id": this.taskId,
                        "unit_class_id": this.classId
                    }).then(res => {
                        if (res.data.response == 'ok') {
                            this.asksList = res.data.data;
                        }
                        this.loading = true;
                    })
                } else if (taskType == 4) {
                    this.$http.post(API_URL_TASK_API + '/chinese/check/reading/task/report', {
                        "message_id": this.taskId,
                        "unit_class_id": this.classId,
                        "re_id": this.reid
                    }).then(res => {
                        if (res.data.response == 'ok') {
                            this.asksList = res.data.data;
                        }
                        this.loading = true;
                    })
                }
            } else {
                this.getlist();
            }
        },
        getlist (url) {
            let that = this;
            this.loading = false;
            let data = {}
            if (this.taskType == 2) {
                if (this.testType == 4) {
                    this.url = '/chinese/check/listen/task/detail';
                } else if (this.testType == 8) {
                    this.url = '/chinese/check/question/task/kxdjc_detail';
                } else if (this.testType == 11) {
                    this.url = '/chinese/check/question/task/qm2020_detail';
                } else if (this.testType == 12) {
                    this.url = '/chinese/check/question/task/qz2021_detail';
                } else {
                    this.url = '/chinese/check/question/task/detail';
                }
                data = {
                    "message_id": this.taskId,
                    "unit_class_id": this.classId
                }
            } else if (this.taskType == 4) {
                this.url = '/chinese/check/reading/task/detail';
                data = {
                    "message_id": this.taskId,
                    "unit_class_id": this.classId,
                    "re_id": this.reid
                }
            }
            this.$http.post(API_URL_TASK_API + this.url, data).then(res => {
                let res1 = res.data;
                if (res1.response == 'ok') {
                    this.loading = true;
                    let data = res.data.data;
                    if (Object.keys(data).length || data.length) {
                        this.finshList = data.students;
                        this.finish = data.finish_num;
                        this.unfinish = data.unfinished_num;
                        this.endDate = data.end_date;
                        this.wrong_num = data.wrong_num || 0;
                        this.average = data.average;
                        this.anums = data.anums;
                        this.bnums = data.bnums;
                        this.cnums = data.cnums;
                        this.dnums = data.dnums;
                        localStorage.setItem('endDate', this.endDate);
                        this.$store.commit('picList', this.finshList);
                        if (res1.data.is_end == 1) {
                            this.flagBoon = true;
                        } else {
                            this.flagBoon = false;
                        }
                    }

                }
            })
        },
        reward () {
            if (this.testType == 4) {
                this.$router.push("/tea/testreward/51/" + this.taskId + "/" + this.classId + "?remark=1");
            } else {
                this.$router.push("/tea/testreward/51/" + this.taskId + "/" + this.classId);
            }
        },
        HDshare () {
            if (this.is_active == 2) { //寒假活动
                this.$router.push(
                    `/activity/2020winter/tea/sharePreview?unit_class_id=${this.classId}&message_id=${this.mid ? this.mid : this.taskId}&sid=51`
                );
            } else {  //暑假活动
                this.$router.push(
                    `/activity/2021summer/tea/sharePreview?unit_class_id=${this.classId}&message_id=${this.taskId}&sid=51`
                );
            }

        }
    },
    components: {
        headers,
        results,
        reports,
        loadingS,
        // analyze
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.content {
    width: 100vw;
    background: #f5f9ff;
    overflow-x: hidden;
    min-height: 100%;
    position: relative;
}

.head {
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    div {
        width: 100%;
        height: 96px / $ppr;
        position: relative;

        .title {
            width: 100%;
            height: 96px / $ppr;
            text-align: center;
            line-height: 96px / $ppr;
            color: #fff;
            font-size: 34px / $ppr;
        }

        .back {
            width: 18px / $ppr;
            height: 36px / $ppr;
            background: url(../img/choose_back.png) no-repeat;
            background-size: 100%;
            position: absolute;
            top: 30px / $ppr;
            left: 24px / $ppr;
        }

        .preview {
            position: absolute;
            top: 30px / $ppr;
            right: 24px / $ppr;
            font-size: 30px / $ppr;
            z-index: 10;
            color: #fff;
        }
    }
}

.time_box {
    width: 100%;
    height: 96px / $ppr;
    margin-top: 96px / $ppr;
    background: #5e89ef;

    .jzTime {
        padding-left: 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        color: #fff;
        font-size: 30px / $ppr;
        float: left;
    }

    .endTime {
        float: right;
        font-size: 30px / $ppr;
        color: #dde7fd;
        margin-right: 24px / $ppr;
        line-height: 96px / $ppr;
    }
}

.notab {
    width: 100%;
    height: 96px / $ppr;
    font-weight: bold;
    line-height: 96px / $ppr;
    text-align: left;
    font-size: 30px / $ppr;
    margin-bottom: 24px / $ppr;
    padding-left: 24px / $ppr;
    background-color: #fff;
    position: relative;
    z-index: 2;
}

.tabs_tit {
    &.marginTop {
        margin-top: 2.4rem;
    }
}

.tabs {
    width: 100%;
    height: 96px / $ppr;
    margin-bottom: 24px / $ppr;
    background-color: #fff;
    display: flex;
    position: relative;
    z-index: 2;

    div {
        float: left;
        font-weight: bold;

        p {
            font-weight: 700;
            margin: 0 auto;
            width: 144px / $ppr;
            height: 93px / $ppr;
            line-height: 96px / $ppr;
            text-align: center;
            font-size: 30px / $ppr;
        }
    }

    div:nth-child(1) {
        width: 360px / $ppr;
        height: 96px / $ppr;
    }

    div:nth-child(2) {
        width: 1px;
        height: 64px / $ppr;
        background: #dcdcdc;
        margin-top: 19px / $ppr;
    }

    div:nth-child(3) {
        margin-left: -1px;
        width: 360px / $ppr;
        height: 96px / $ppr;
    }
}

.check {
    border-bottom: 4px / $ppr solid #5e89ef;
    color: #5e89ef;
}

.nocheck {
    color: #333;
}

.noresources {
    width: 100%;
    height: 300px / $ppr;

    p {
        line-height: 300px / $ppr;
        text-align: center;
    }
}

.bottom_btn1 {
    .bottom_btn-div {
        width: 50%;
    }
}

.bottom_btn2 {
    .bottom_btn-div {
        width: 100%;
    }
}

.bottom_btn {
    width: 100%;
    height: 98px / $ppr;
    margin-top: 25px / $ppr;

    .bottom_btn-box {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
    }

    .share {
        background: #5e89ef;
    }

    .reward {
        background: #ff6600;
    }

    .reward,
    .share {
        color: #fff;

        p {
            text-align: center;
            margin: 0 auto;
            line-height: 98px / $ppr;
            // padding-left:50px/$ppr;
            position: relative;
        }

        img {
            display: inline-block;
            position: relative;
            width: 40px / $ppr;
            top: 8px / $ppr;
            margin-right: 10px / $ppr;
        }
    }
}
</style>
